import { useContext } from 'react';
import DevRoleContext from '../contexts/DevRoleContext';

const useDevRole = () => useContext(DevRoleContext);

export default useDevRole;
